import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
type Faq = {
  question: string;
  answer: string;
};
const faqs: Faq[] = [{
  question: '¿El libro está en español?',
  answer: 'Sí. Toda la explicación está en español para tu comodidad. Los guiones que usarás con tu hijo vienen en español e inglés.'
}, {
  question: '¿Funciona si mi hijo aún no habla mucho?',
  answer: 'Especialmente ahí. La guía te enseña a traducir sus gestos y necesidades antes de que se conviertan en berrinches.'
}, {
  question: '¿Es difícil de aprender?',
  answer: 'No. La Regla de las 3 Palabras fue creada para mamás ocupadas: puedes entenderla y empezar a usarla en unos 5 minutos.'
}, {
  question: '¿Qué pasa si mi esposo solo habla inglés?',
  answer: 'Los Mirror-Scripts™ son bilingües, así que él también podrá usarlos para conectar y calmar al niño.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="mx-auto max-w-3xl px-5 py-20 sm:px-8" data-id="element-1">
      <p className="eyebrow" data-id="element-2">RESPUESTAS CLARAS</p>
      <h2 id="faq-title" className="mt-3 font-serif text-4xl leading-tight text-[#3c2b23] sm:text-5xl" data-id="element-3">
        Preguntas de mamá, respondidas.
      </h2>
      <div className="mt-10 border-t border-[#dacdbb]" data-id="element-4">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        const contentId = `faq-answer-${index}`;
        return <div key={faq.question} className="border-b border-[#dacdbb]" data-id="element-5">
              <h3 data-id="element-6">
                <button type="button" className="flex w-full items-center justify-between gap-4 py-6 text-left text-lg font-bold text-[#3c2b23] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#a84b35] focus-visible:ring-offset-4" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={contentId} data-id="element-7">
                  <span data-id="element-8">{faq.question}</span>
                  <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 flex-none text-[#a84b35] transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-9" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-10">
                {isOpen && <motion.div id={contentId} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22
            }} className="overflow-hidden" data-id="element-11">
                    <p className="max-w-2xl pb-6 pr-8 text-base leading-7 text-[#6a584d]" data-id="element-12">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}